import React from 'react'
import injectStyles from 'react-jss'
import styles from './styles'
import { CHAT_MESSAGE_TYPES } from '../../../../../shared/constants'

import VideocamIcon from '@material-ui/icons/Videocam'
import DescriptionIcon from '@material-ui/icons/Description'

const mediaPreviewTypes = {
  [CHAT_MESSAGE_TYPES.VIDEO]: {
    label: 'Video',
    icon: <VideocamIcon />,
  },
  [CHAT_MESSAGE_TYPES.FILE]: {
    label: 'File',
    icon: <DescriptionIcon />,
  },
}

const ChatMediaPreview = ({ type, fileURL, classes }) => {
  const { icon, label } = mediaPreviewTypes[type]
  return (
    <a href={fileURL} target="_blank" className={classes.wrapper}>
      <div className={classes.iconWrapper}>{icon}</div>
      <span className={classes.label}>{label}</span>
    </a>
  )
}

export default injectStyles(styles)(ChatMediaPreview)



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatMessage/contents/ChatMediaPreview/ChatMediaPreview.js